import { colors } from "./colors"

export const borders = {
  radio: {
    navy: "1px solid " + colors.accents.navy.primary,
    black: "1px solid " + colors.black,
  },
}
